<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Refunded</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <router-link to="/redeem">Refunded</router-link> /
      <b>Summary</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <p>The page shows the summary of the refunds.</p>

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">

            <h4 class="card-title mb-3">Summary</h4>

            <div class="row">
                <div class="col-md-6 form-group mb-3">
                    <label>Refunded By</label>
                    <input class="form-control" v-model="refund.balance[0].account_number" disabled />
                </div>
                
                <div class="col-md-6 form-group mb-3">
                    <label>Points Refunded</label>
                    <input class="form-control" v-model="refund.points_redeemed" disabled />
                </div>

                <div class="col-md-6 form-group mb-3">
                    <label>Price Refunded</label>
                    <input class="form-control" v-model="refund.price_redeemed" disabled />
                </div>

                <div class="col-md-6 form-group mb-3">
                    <label>Date Redeemed</label>
                    <input class="form-control" v-model="refund.updated_at" disabled />
                </div>
            </div>

            <hr style="border:white">

            <router-link class="btn btn-primary" to="/refund">
                Back
            </router-link>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style>
.active {
  background: none;
}
</style>


<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";

export default {
  name: "vendor-redeem-summary",
  components: {
  },

  data() {
    return {
        refund: []
    }
  },

  methods: {
      loadRedeem() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/transaction/refund/" + id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            if(res.data.success){
              this.refund = res.data.refund;
  
              this.refund.updated_at = moment(new Date(this.refund.updated_at)).format("Do MMMM YYYY, h:mm a")
        
            } else{
              swal({
                icon: "error",
                title: "Error",
                text: res.data.message
              })
              .then(() => {
                localStorage.clear()
                this.$router.push("/login");
              })
            }


          })
      }
    },
  },

  mounted() {
      this.loadRedeem()
  }
};
</script>